module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"price":"price","weight":"weight","amount":"amount","apply_to_all":"Apply {text} to all","this_will_applied_all":"This {text} will be applied to all products in this page"},"id":{"price":"Harga","weight":"Berat","amount":"Jumlah","apply_to_all":"Terapkan {text} kepada semua","this_will_applied_all":"{teks} ini akan diterapkan ke semua produk di halaman ini"}}')
  delete Component.options._Ctor
}
